/**
 * Redux Store 配置
 */
import { configureStore } from '@reduxjs/toolkit';

// 创建一个简单的初始状态
const initialState = {
  user: {
    isAuthenticated: false,
    userInfo: null,
  },
  app: {
    loading: false,
    error: null,
  },
};

// 简单的reducer
const rootReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        app: {
          ...state.app,
          loading: action.payload,
        },
      };
    case 'SET_ERROR':
      return {
        ...state,
        app: {
          ...state.app,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

// 配置store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;